import { sendToAdobeAnalyticsOnClick } from 'common/utils/utils';
import { useTranslation } from 'react-i18next';

import ExternalIcon from '../components/ExternalIcon';

import './styles.css';

export const MagicMovieAdditionalResources: React.FC = () => {
  const { t } = useTranslation(['magicMovie']);
  const handleClickForStartBuilding = () => {
    sendToAdobeAnalyticsOnClick({
      type: 'click',
      name: 'Start building button click event',
      description: 'Event is triggered when user clicks on start building button on additional resources page',
    });
    window.open('https://console.aws.amazon.com/personalize/home', '_blank', 'noopener noreferrer');
  };
  return (
    <div id="game" className="gameContainer header-spaced" data-test-id="magicMovieAdditionalResourcesRoot">
      <h1 className="header-spaced">{t('additionalResources.thanks')}</h1>
      <p className="blue" style={{ marginBottom: '40px' }}>
        {t('additionalResources.weHope')}
      </p>
      <div className="external-links">
        <ul className="blue">
          <li>
            <span className="custom_external_link">
              <a
                href="https://github.com/aws-samples/amazon-personalize-samples/blob/master/next_steps/workshops/magic_movie_machine/notebooks/Building%20the%20Magic%20Movie%20Machine%20Recommender.ipynb"
                target="_blank"
                rel="noopener noreferrer"
                data-analytics-type="eventDetail"
                data-analytics="howserMagicMovieAdditionalResourceBuildDemoLink"
              >
                {t('additionalResources.buildDemo')}
                <ExternalIcon
                  style={{
                    stroke: '#44b9d6',
                    marginLeft: '.2em',
                    width: '20px',
                    height: '20px',
                  }}
                />
              </a>
            </span>
          </li>
          <li>
            <span className="custom_external_link">
              <a
                href="https://explore.skillbuilder.aws/learn/course/external/view/elearning/12437/getting-started-with-amazon-personalize"
                target="_blank"
                rel="noopener noreferrer"
                data-analytics-type="eventDetail"
                data-analytics="howserMagicMovieAdditionalResourceLearnMoreLink"
              >
                {t('additionalResources.learnMore')}
                <ExternalIcon
                  style={{
                    stroke: '#44b9d6',
                    width: '20px',
                    height: '20px',
                    marginLeft: '.2em',
                  }}
                />
              </a>
            </span>
          </li>
        </ul>
      </div>

      <div className="additional-resources-buttons">
        <button
          className="customButton"
          style={{
            maxWidth: '400px',
            fontSize: '24px',
            padding: '20px',
            borderRadius: '4px',
            background: 'orange',
            color: '#16191F',
          }}
          onClick={handleClickForStartBuilding}
          data-analytics-type="eventDetail"
          data-analytics="howserMagicmovieAdditionalResourceNextBuildDemoButton"
          data-test-id="magicMovieAdditionalResourcesDemoButton"
        >
          {t('additionalResources.nextBuildDemo')}
        </button>
        <button
          className="customButton"
          style={{
            maxWidth: '200px',
            fontSize: '24px',
            padding: '20px',
            borderRadius: '4px',
          }}
          onClick={() => {
            window.open('https://aws.amazon.com/personalize/', '_blank', 'noopener noreferrer');
          }}
          data-analytics-type="eventDetail"
        >
          {t('additionalResources.learnMoreButton')}
        </button>
      </div>
    </div>
  );
};

export default MagicMovieAdditionalResources;
